import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTestCenterList } from 'src/store/slices/testCenterSlice'
import ClinicCard from 'src/mobile/components/ClinicCard'
import { Virtuoso } from 'react-virtuoso'
import EmptyClinic from 'src/mobile/components/EmptyClinic'
import { useTranslation } from 'react-i18next'
// import SnackbarHelperText from 'src/mobile/components/SnackbarHelperText'
import FilterBar from 'src/mobile/layout/FilterBar'
import TopStickyBar from 'src/mobile/layout/TopStickyBar'
import useUserSession from 'src/hooks/useUserSession'
import {
  Box,
  Typography,
  makeStyles,
  createStyles,
  Divider,
  useTheme,
  useMediaQuery,
  Grid,
} from '@material-ui/core'
import { PACKAGE_INFO, MOBILE_HEADER_HEIGHT } from 'src/utils/constant'
import { ReactComponent as Return } from '../../assets/icons/Return.svg'
import { useHistory } from 'react-router-dom'
import DetailModal from 'src/mobile/components/DetailModal'
import ClinicStep from 'src/mobile/components/ClinicStep'
const useStyles = makeStyles((theme) =>
  createStyles({
    sidebarTank: {
      width: theme.spacing(40),
      flexShrink: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(4),
      backgroundColor: '#fff',
    },
    sidebarContent: {
      flexGrow: 1,
      padding: 0,
      maxWidth: theme.spacing(150),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingRight: '106px',

      paddingLeft: theme.spacing(5),
      borderLeft: '1px solid #E5E7EB',
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    },
    flexLayout: {
      display: 'flex',
      minHeight: 800,
      backgroundColor: '#FAFAFA',
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0, 0),
        minHeight: 400,
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT + 2),
      },
    },
    icon: {
      flexShrink: 0,
      width: theme.spacing(3),
      height: theme.spacing(3),
      '& path': {
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        fill: theme.palette.grey[800],
      },
    },
    back: {
      borderRadius: '100px',
      height: '56px',
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        width: '100px',
        height: '40px',
        fontSize: 14,
      },
    },
  }),
)

const HomePage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const { authenticated } = useUserSession()
  const [area, setArea] = useState('')
  const history = useHistory()
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const { selectedDoctor } = useSelector((state) => state.testCenter)
  const { testCenterList, testCenterListStatus } = useSelector((state) => state.testCenter)
  const handleFilter = (e) => setArea(e.target.value)
  const [value, setValue] = useState(selectedDoctor?.package ? selectedDoctor?.package : '1')
  // const handleFilter2 = ({ value }) => {
  //   setValue(value)
  // }

  // const PROGRAM_ITEM = [
  //   { label: t('form.all_program'), value: '0', id: '' },
  //   { label: t('form.npc'), value: '1', id: 'EH_ClinicHP_Prophecy_Tab' },
  //   { label: t('form.cancer'), value: '2', id: 'EH_ClinicHP_CancerMarker_Tab' },
  //   { label: t('form.physical_examination_basic'), value: '3', id: 'EH_ClinicHP_StandardHealthCheck_Tab' },
  //   { label: t('form.physical_examination'), value: '4', id: 'EH_ClinicHP_ComprehensiveHealthCheck_Tab' },
  // ]

  const backButton = () => {
    return (
      <Box
        mt={1}
        color="primary.main"
        fontSize={14}
        fontWeight={700}
        border="1px solid #E5E7EB"
        borderRadius="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={isMobile ? '80px' : '150px'}
        className={classes.back}
        onClick={() => {
          history.push(`/${i18n.language}` + PACKAGE_INFO[value].path, { pack: value })
        }}
      >
        <Return />
        {t('common.page_hone')}
      </Box>
    )
  }

  const areaSelect = () => {
    return (
      <Box
        display="flex"
        bgcolor="background.default"
        justifyContent={isMobile ? 'space-between' : ''}
        alignItems="center"
        px={2}
        py={1.5}
      >
        <FilterBar onChange={handleFilter} />
        <Box
          color="primary.main"
          fontSize={isMobile ? 14 : 16}
          fontWeight={600}
          px={2}
          py={0.625}
          flexShrink={0}
          bgcolor="background.default"
          display="flex"
        >
          {t('common.filter', { all: list?.length })}
        </Box>
        {/* <FilterBar onChange={handleFilter2} options={PROGRAM_ITEM} defaults={value} /> */}
      </Box>
    )
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    setValue(selectedDoctor?.package)
    dispatch(getTestCenterList({ clinicType: 1 }))
  }, [])

  const list = useMemo(() => {
    if (value && value !== '4' && value !== '0') {
      return area
        ? testCenterList?.filter(
            (testCenter) =>
              testCenter.package?.indexOf(value) !== -1 &&
              testCenter.area === area &&
              testCenter.package !== null,
          )
        : testCenterList?.filter(
            (testCenter) => testCenter.package?.indexOf(value) !== -1 && testCenter.package !== null,
          )
    }
    if (value === '4') {
      return area
        ? testCenterList?.filter(
            (testCenter) =>
              !area ||
              (testCenter.area === area &&
                testCenter.package?.indexOf('4') !== -1 &&
                testCenter.package !== null) ||
              !area ||
              (testCenter.area === area &&
                testCenter.package?.indexOf('5') !== -1 &&
                testCenter.package !== null),
          )
        : testCenterList?.filter(
            (testCenter) =>
              (testCenter.package?.indexOf('4') !== -1 || testCenter.package?.indexOf('5') !== -1) &&
              testCenter.package !== null,
          )
    }
    if (value === '0') {
      return testCenterList?.filter((testCenter) => !area || testCenter.area === area)
    }
  }, [testCenterList, area, value])

  return (
    <>
      <TopStickyBar>
        <Box px={isMobile ? 2 : 0}>
          <Typography variant={isMobile ? 'h4' : 'h6'} noWrap>
            <DetailModal
              value={Number(value)}
              price={Number(selectedDoctor?.price)}
              currency={Number(selectedDoctor?.currency)}
            />
            {isMobile ? <Divider /> : ''}
            {isMobile && (
              <>
                {backButton()}
                <Box my={1} color="primary.main" fontSize={16} fontWeight={600}>
                  {t('common.select_site')}
                </Box>{' '}
              </>
            )}
          </Typography>
        </Box>
        {isMobile && areaSelect()}
      </TopStickyBar>

      {list?.length > 0 && isMobile && (
        <Virtuoso
          useWindowScroll
          style={{
            marginBottom: 60,
            flexGrow: 1,
            height: 'calc(100vh - 110px)',
            // minHeight: isMobile ? '70vh' : '',
            background: isMobile ? '' : 'rgb(250, 250, 250)',
          }}
          data={list}
          itemContent={(index, item) => {
            return (
              <>
                <ClinicCard
                  authenticated={authenticated}
                  clinic={item}
                  packages={value}
                  price={selectedDoctor?.price}
                  currency={selectedDoctor?.currency}
                />
                {list?.length === index + 1 && (
                  <Box color="grey.400" textAlign="center" mt={2}>
                    ---- For all service provider loaded ----
                    <Box fontSize={14} px={3} textAlign="left" mt={1.5}>
                      {t('common.declare_duty')}
                    </Box>
                  </Box>
                )}
              </>
            )
          }}
        />
      )}

      {!isMobile && (
        <Box className={classes.flexLayout}>
          <Box className={classes.sidebarTank}>
            <ClinicStep />
          </Box>

          <main className={classes.sidebarContent}>
            {areaSelect()}
            {list?.length > 0 ? (
              <Grid container spacing={2}>
                {list.map((item, index) => {
                  return (
                    <Grid item xs={12} md={6} key={item.id}>
                      <Box
                        style={{ cursor: 'pointer' }}
                        //  maxWidth={500}
                      >
                        <ClinicCard
                          authenticated={authenticated}
                          clinic={item}
                          packages={value}
                          price={selectedDoctor?.price}
                          currency={selectedDoctor?.currency}
                        />
                      </Box>
                    </Grid>
                  )
                })}
                <Box color="#9CA3AF" textAlign="center" mt={2}>
                  ---- For all service provider loaded ----
                  <Box fontSize={16} textAlign="left" color="#4B5563" mt={3}>
                    {t('common.declare_duty')}
                  </Box>
                </Box>
              </Grid>
            ) : (
              <EmptyClinic
                fontSize={18}
                title={t('glossary.appointment_process_list.empty')}
                status={testCenterListStatus}
              />
            )}
          </main>
        </Box>
      )}
      {!list?.length && isMobile && (
        <EmptyClinic title={t('glossary.appointment_process_list.empty')} status={testCenterListStatus} />
      )}
    </>
  )
}

export default HomePage
